import React from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    svg: {
      // height: '500px',
    },
    st0: { fill: 'none', stroke: '#0076BC', strokeWidth: '2' },
    st1: { fill: '#0076BC' },
    st2: { fontWeight: 'bold' },
    st3: { fontSize: '9px' },
    st4: { fontSize: '7.68px' },
    st5: { fill: '#414042' },
    st6: { fontWeight: 'lighter' },
    st7: { fontSize: '8px' },
    st8: { fill: '#00ADD8' },
    st9: { fill: '#FFFFFF' },
    st10: { fontSize: '10.9855px' },
    draw: {
      animation: `$draw 1.5s linear forwards`,
      transformOrigin: '25% 100%',
      transform: 'scaleX(0)',
    },
    drawRight: {
      animation: `$draw 1.5s linear forwards`,
      transformOrigin: '60% 100%',
      transform: 'scaleX(0)',
    },

    '@keyframes draw': {
      ...animationFunc(),
    },
  }),
);

function animationFunc() {
  return {
    to: {
      transform: 'scaleX(1)',
    },
  };
}

const FoodCrises = () => {
  const classes = useStyles();

  const [ref, inView] = useInView({
    threshold: 0,
  });

  return (
    <svg
      ref={ref}
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      className={classes.svg}
      viewBox="0 0 340.89 332.28"
    >
      <g>
        <g>
          <line className={classes.st0} x1="75.16" y1="294.52" x2="75.16" y2="10.95" />
        </g>
        <text
          transform="matrix(1 0 0 1 17.1005 41.701)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          Democratic
        </text>
        <text
          transform="matrix(1 0 0 1 17.0282 52.5907)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          Republic Of
        </text>
        <text
          transform="matrix(1 0 0 1 21.3124 63.4803)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          The Congo
        </text>
        <text
          transform="matrix(1 0 0 1 37.0443 23.0975)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          Yemen
        </text>
        <text
          transform="matrix(1 0 0 1 31.4374 140.7635)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          Ethiopia
        </text>
        <text
          transform="matrix(1 0 0 1 26.5956 252.4627)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          Northern
        </text>
        <text
          transform="matrix(1 0 0 1 35.6942 263.3524)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          Nigeria
        </text>
        <text
          transform="matrix(1 0 0 1 16.7855 194.2782)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          Syrian
        </text>
        <text
          transform="matrix(1 0 0 1 43.8798 194.2762)"
          className={clsx(classes.st1, classes.st2, classes.st4)}
        >
          {' '}
        </text>
        <text
          transform="matrix(1 0 0 1 46.3944 194.2762)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          Arab
        </text>
        <text
          transform="matrix(1 0 0 1 29.7084 205.1668)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          Republic
        </text>
        <text
          transform="matrix(1 0 0 1 22.4364 100.5145)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          Venezuela
        </text>
        <text
          transform="matrix(1 0 0 1 20.3754 111.4041)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          (Bolivarian{' '}
        </text>
        <text
          transform="matrix(1 0 0 1 14.1654 122.2948)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          Republic Of)
        </text>
        <text
          transform="matrix(1 0 0 1 14.8134 82.0555)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          Afghanistan
        </text>
        <text
          transform="matrix(1 0 0 1 39.8422 228.5487)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          Sudan
        </text>
        <text
          transform="matrix(1 0 0 1 12.0956 170.1024)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          South Sudan
        </text>
        <text
          transform="matrix(1 0 0 1 46.5116 287.5077)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          Haiti
        </text>
        <text
          transform="matrix(1 0 0 1 176.1503 320.6385)"
          className={clsx(classes.st5, classes.st6, classes.st7)}
        >
          number of people in crisis{' '}
        </text>
        <g>
          <path
            className={classes.st8}
            d="M164.67,324.88c4.03,0,7.3-3.27,7.3-7.3s-3.27-7.3-7.3-7.3s-7.3,3.27-7.3,7.3S160.64,324.88,164.67,324.88"
          />
        </g>
        <text
          transform="matrix(1 0 0 1 32.3885 320.6385)"
          className={clsx(classes.st5, classes.st6, classes.st7)}
        >
          % of population analysed in crisis{' '}
        </text>
        <g>
          <path
            className={clsx(classes.st1)}
            d="M21.41,324.88c4.03,0,7.3-3.27,7.3-7.3s-3.27-7.3-7.3-7.3s-7.3,3.27-7.3,7.3S17.37,324.88,21.41,324.88"
          />
          <path
            className={clsx(classes.st1, inView && classes.draw)}
            d="M178.76,29.42c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H178.76z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_1_"
                d="M89.62,10.4c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h89.14
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st1, inView && classes.draw)}
            d="M147.25,117.48c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H147.25z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_3_"
                d="M89.62,98.45c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h57.63
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st1, inView && classes.draw)}
            d="M154.71,205.53c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H154.71z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_5_"
                d="M89.62,186.51c-3.13,0-5.67,2.54-5.67,5.67v7.69c0,3.13,2.54,5.67,5.67,5.67h65.09
                        c3.13,0,5.67-2.54,5.67-5.67v-7.69c0-3.13-2.54-5.67-5.67-5.67H89.62z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st1, inView && classes.draw)}
            d="M137.63,58.77c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H137.63z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_7_"
                d="M89.62,39.75c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h48.01
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st1, inView && classes.draw)}
            d="M137.63,146.83c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H137.63z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_9_"
                d="M89.62,127.8c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h48.01
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st1, inView && classes.draw)}
            d="M116.5,234.88c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H116.5z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_11_"
                d="M89.62,215.86c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h26.88
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st1, inView && classes.draw)}
            d="M154.71,88.12c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H154.71z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_13_"
                d="M89.62,69.1c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h65.09
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st1, inView && classes.draw)}
            d="M193.96,176.18c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H193.96z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_15_"
                d="M89.62,157.16c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h104.34
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st1, inView && classes.draw)}
            d="M99.26,264.23c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67h-9.64
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H99.26z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_17_"
                d="M89.62,245.21c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h9.64
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st1, inView && classes.draw)}
            d="M147.25,293.58c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H147.25z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_19_"
                d="M89.62,274.56c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h57.63
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H89.62z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st8, inView && classes.drawRight)}
            d="M325.91,29.42c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H210.63
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H325.91z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_21_"
                d="M210.63,10.4c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H325.9
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H210.63z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st8, inView && classes.drawRight)}
            d="M320.55,58.77c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H210.63
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H320.55z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_23_"
                d="M210.63,39.75c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h109.92
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H210.63z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st8, inView && classes.drawRight)}
            d="M299.77,88.12c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67h-89.14
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H299.77z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_25_"
                d="M210.63,69.1c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h89.14
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H210.63z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st8, inView && classes.drawRight)}
            d="M285.47,117.48c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67h-74.84
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H285.47z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_27_"
                d="M210.63,98.45c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h74.84
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H210.63z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st8, inView && classes.drawRight)}
            d="M277.01,146.83c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67h-66.37
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H277.01z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_29_"
                d="M210.63,127.8c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H277
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H210.63z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st8, inView && classes.drawRight)}
            d="M272.27,176.18c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67h-61.64
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H272.27z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_31_"
                d="M210.63,157.16c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h61.64
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H210.63z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st8, inView && classes.drawRight)}
            d="M263.92,205.53c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67h-53.29
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H263.92z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_33_"
                d="M210.63,186.51c-3.13,0-5.67,2.54-5.67,5.67v7.69c0,3.13,2.54,5.67,5.67,5.67h53.29
                        c3.13,0,5.67-2.54,5.67-5.67v-7.69c0-3.13-2.54-5.67-5.67-5.67H210.63z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st8, inView && classes.drawRight)}
            d="M257.64,234.88c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67h-47.01
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H257.64z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_35_"
                d="M210.63,215.86c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h47.01
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H210.63z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st8, inView && classes.drawRight)}
            d="M250.46,264.23c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67h-39.83
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H250.46z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_37_"
                d="M210.63,245.21c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h39.83
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H210.63z"
              />
            </defs>
          </g>
        </g>
        <g>
          <path
            className={clsx(classes.st8, inView && classes.drawRight)}
            d="M231.86,293.58c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67h-21.23
                c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67H231.86z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_39_"
                d="M210.63,274.56c-3.13,0-5.67,2.54-5.67,5.67v7.68c0,3.13,2.54,5.67,5.67,5.67h21.23
                        c3.13,0,5.67-2.54,5.67-5.67v-7.68c0-3.13-2.54-5.67-5.67-5.67H210.63z"
              />
            </defs>
          </g>
        </g>

        <text
          transform="matrix(1 0 0 1 87.704 24.1131)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          53%
        </text>

        <text
          transform="matrix(1 0 0 1 87.704 53.4666)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          26%
        </text>

        <text
          transform="matrix(1 0 0 1 87.704 82.8192)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          37%
        </text>

        <text
          transform="matrix(1 0 0 1 87.704 112.1727)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          32%
        </text>
        <text
          transform="matrix(1 0 0 1 87.704 141.5262)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          27%
        </text>
        <text
          transform="matrix(1 0 0 1 87.704 170.8797)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          61%
        </text>
        <text
          transform="matrix(1 0 0 1 87.704 200.2323)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          36%
        </text>
        <text
          transform="matrix(1 0 0 1 87.704 229.5858)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          14%
        </text>
        <text
          transform="matrix(1 0 0 1 87.704 258.9393)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          5%
        </text>
        <text
          transform="matrix(1 0 0 1 87.704 288.2928)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          35%
        </text>
        <text
          transform="matrix(1 0 0 1 209.8627 24.1351)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          15.9 M
        </text>
        <text
          transform="matrix(1 0 0 1 209.8627 53.4881)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          15.6 M
        </text>
        <text
          transform="matrix(1 0 0 1 209.8627 82.8416)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          11.3 M
        </text>
        <text
          transform="matrix(1 0 0 1 208.3246 112.1952)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          9.3 M
        </text>
        <text
          transform="matrix(1 0 0 1 208.3246 141.5477)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          8 M
        </text>
        <text
          transform="matrix(1 0 0 1 208.3246 170.9012)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          7 M
        </text>
        <text
          transform="matrix(1 0 0 1 208.3246 200.2547)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          6.6 M
        </text>
        <text
          transform="matrix(1 0 0 1 208.3246 229.6082)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          5.9 M
        </text>
        <text
          transform="matrix(1 0 0 1 208.3246 258.9608)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          5 M
        </text>
        <text
          transform="matrix(1 0 0 1 208.3246 288.3143)"
          className={clsx(classes.st9, classes.st2, classes.st10)}
        >
          3.7 M
        </text>
      </g>
    </svg>
  );
};

export default FoodCrises;
